import { Button, ButtonVariant, StyledFlex } from '@dreryk/react-components';

import { invoicePanelTranslationKeys } from '../translations';

import { InvoiceCreateAccountModalOpener } from './invoiceCreateAccount/InvoiceCreateAccountModalOpener';
import {
   StyledInvoicePanelBanner,
   StyledInvoicePanelBannerButton,
   StyledInvoicePanelBannerHeading,
} from './InvoicePanelBanner.styled';
import { openUrlInNewTab } from './utils';

type InvoicePanelBannerProps = {
   readonly invoiceOfferUrl: string;
};

export const InvoicePanelBanner = (props: InvoicePanelBannerProps): JSX.Element => {
   return (
      <StyledInvoicePanelBanner>
         <StyledInvoicePanelBannerHeading
            content={invoicePanelTranslationKeys.bannerTitle}
            testId={'bannerHeading'}
            type={'h2'}
            bold
         />
         <StyledFlex justifyContent={'flex-end'} gap={'4px'}>
            <StyledInvoicePanelBannerButton
               label={invoicePanelTranslationKeys.invoiceOffer}
               testId={'invoiceOfferUrl'}
               variant={ButtonVariant.SECONDARY}
               onClick={openUrlInNewTab(props.invoiceOfferUrl)}
            />
            <InvoiceCreateAccountModalOpener>
               {({ openModal }) => (
                  <Button
                     label={invoicePanelTranslationKeys.createAccount}
                     testId={'createAccount'}
                     variant={ButtonVariant.PRIMARY}
                     onClick={openModal}
                  />
               )}
            </InvoiceCreateAccountModalOpener>
         </StyledFlex>
      </StyledInvoicePanelBanner>
   );
};
